import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectListViewComponent } from './views/project-list-view/project-list-view.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { projectListReducer } from './store';
import { EffectsModule } from '@ngrx/effects';
import { ProjectEntityListEffects } from './store/project-entity-list/project-entity-list.effects';
import { ProjectListTableComponent } from './components/project-list-table/project-list-table.component';
import { ProjectListPagingComponent } from './components/project-list-paging/project-list-paging.component';
import { ProjectListFilterComponent } from './components/project-list-filter/project-list-filter.component';
import { ConfirmDeleteDialogComponent } from './components/confirm-delete-dialog/confirm-delete-dialog.component';

@NgModule({
  declarations: [
    ProjectListViewComponent,
    ProjectListTableComponent,
    ProjectListPagingComponent,
    ProjectListFilterComponent,
    ConfirmDeleteDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    StoreModule.forFeature('projectList', projectListReducer),
    EffectsModule.forFeature([ProjectEntityListEffects])
  ],
  exports: [ProjectListViewComponent, ProjectListPagingComponent]
})
export class ProjectListModule {}
